var selectedPatches = {};
let basePrice = 0;
document.addEventListener('DOMContentLoaded', function () {
  
  /* ---------------- MONEY FORMAT ---------------- */
  const moneyFormat = "{{ shop.money_format }}";
  
  function formatMoney(cents) {
    if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
      return Shopify.formatMoney(cents, moneyFormat);
    }
    return (cents / 100).toFixed(2);
  }


  /* ================================
     GLOBAL STATE
  ================================ */
  // const selectedPatches = {};
  let firstPatchAdded = false;

  /* ================================
     ELEMENTS
  ================================ */
  const patchGrid = document.getElementById('patchGrid');
  const overlay = document.getElementById('patchOverlay');
  const priceEl = document.getElementById('totalPrice');

  const swapList = document.getElementById('swapList');
  const swapCountEl = document.getElementById('swapCount');
  const bundleHint = document.getElementById('bundleHint');

  const promoText = document.getElementById('promoText');
  const promoProgress = document.getElementById('promoProgress');

  const imageWrapper = document.querySelector('.image-wrapper');
  const mainImage = imageWrapper?.querySelector('img');  
  // const mainImage = document.querySelector('.image-wrapper img');
  const pillThumb = document.getElementById('activeStyleThumb');

  const styleModal = document.getElementById('styleModal');
  const detailsModal = document.getElementById('detailsModal');


  /* ================================
     URL PARAMS (DECLARE ONCE)
  ================================ */
  const params = new URLSearchParams(window.location.search);
  const baseVariantId = params.get('base');
  const sizeFromUrl   = params.get('size');
  const materialFromUrl = params.get('material'); 
  
  /* ================================
   LOAD VARIANT IMAGE FROM ?variant=
================================ */
const variantIdFromUrl = params.get('variant');

if (variantIdFromUrl) {

  fetch(window.location.pathname + '.js')
    .then(res => res.json())
    .then(product => {

      const variant = product.variants.find(v => v.id == variantIdFromUrl);

      if (!variant) return;

      // Update only main image (do not touch base logic)
      if (mainImage && variant.featured_image) {
        mainImage.src = variant.featured_image.src;
      }

    })
    .catch(err => console.log('Variant load error', err));
}


  /* ===============================
   PATCH SIZE SELECTOR (REQUIRED)
================================ */

const patchSizeButtons = document.querySelectorAll('.patch-size-btn');

patchSizeButtons.forEach(btn => {
  btn.addEventListener('click', function () {

    // Active button state
    patchSizeButtons.forEach(b => b.classList.remove('active'));
    this.classList.add('active');

    const size = this.dataset.size.toLowerCase();
    window.selectedPatchSize = size;

    /* ==============================
       1️⃣ UPDATE OVERLAY CLASS
    ============================== */
    overlay.classList.remove('overlay-big', 'overlay-small');
    overlay.classList.add(`overlay-${size}`);

    /* ==============================
       2️⃣ UPDATE ALL PATCH IMAGES
    ============================== */
    const patchImages = overlay.querySelectorAll('img');

    patchImages.forEach(img => {

      img.classList.remove('patch-big', 'patch-small');
      img.classList.add(`patch-${size}`);

    });

  });
});
  /* ================================
     APPLY BASE IMAGE (BACK VIEW)
  ================================ */
  if (baseVariantId && window.BASE_LOOKUP?.[baseVariantId]) {
    const baseData = window.BASE_LOOKUP[baseVariantId];

    

    if (mainImage) {
      mainImage.src = baseData.image;
      mainImage.alt = baseData.title;
    }

    if (pillThumb) {
      pillThumb.src = baseData.thumb;
      pillThumb.alt = baseData.title;
    }
  if (baseData.price) {
  basePrice = Number(baseData.price);
  updatePrice(); // ✅ ADD THIS
}
    window.bundleBase = {
      variantId: baseVariantId,
      title: baseData.title,
      size: sizeFromUrl
    };
  }

  
  /* ==============================
   APPLY MATERIAL CLASS FROM URL
============================== */

if (materialFromUrl && mainImage) {

  const cleanMaterial = materialFromUrl
    .toLowerCase()
    .replace(/\s+/g, '-');

  // Remove existing jacket-* classes safely
 imageWrapper.classList.forEach(cls => {
  if (cls.startsWith('jacket-')) {
    imageWrapper.classList.remove(cls);
  }
});

imageWrapper.classList.add('jacket-' + cleanMaterial);

}

  /* ================================
     RESTORE SIZE FROM URL
  ================================ */
  if (sizeFromUrl) {

    const radio = document.querySelector(
      `input[type="radio"][value="${sizeFromUrl}"]`
    );
    if (radio) {
      radio.checked = true;
      radio.dispatchEvent(new Event('change', { bubbles: true }));
    }

    const select = document.querySelector('select[name*="Size"]');
    if (select) {
      select.value = sizeFromUrl;
      select.dispatchEvent(new Event('change', { bubbles: true }));
    }

    document.querySelectorAll('.choose-size__btn').forEach(btn => {
      btn.classList.toggle(
        'is-active',
        btn.dataset.size === sizeFromUrl
      );
    });
  }

 /* ===============================
   PATCH + WISHLIST CLICK
=============================== */
patchGrid.addEventListener('click', function (e) {

  const patchEl = e.target.closest('.patch-item');
  if (!patchEl) return;

  // Stop default behavior if any
  e.preventDefault();

  // 🔒 PATCH SIZE VALIDATION
  if (!window.selectedPatchSize || window.selectedPatchSize === '') {
    alert('Please select patch size first');
    return;
  }

  /* ⭐ Wishlist */
  if (e.target.closest('.wishlist-btn')) {
    document.getElementById('wishlistModal')?.classList.add('active');
    return;
  }

  /* ✅ FIND MATCHING VARIANT */
  const variants = JSON.parse(patchEl.dataset.variants || '[]');

  const match = variants.find(v => 
    v.size && v.size.toLowerCase() === window.selectedPatchSize.toLowerCase()
  );

  if (!match) {
    alert(`This patch is not available in ${window.selectedPatchSize}`);
    return;
  }

  const variantId = match.id;
  const image = patchEl.dataset.image;
  const price = Number(patchEl.dataset.price);

  if (!selectedPatches[variantId]) {
    selectedPatches[variantId] = {
      qty: 1,
      price,
      image,
      patchSize: window.selectedPatchSize
    };

    addOverlayImage(variantId, image);
    bundleHint.style.display = 'none';

  } else {
    selectedPatches[variantId].qty += 1;
  }

  updateMySwapsUI();
  updatePrice();
  updatePromo();
});


  /* ================================
     OVERLAY IMAGE
  ================================ */
 function addOverlayImage(id, image) {

  if (overlay.querySelector(`img[data-id="${id}"]`)) return;

  const img = document.createElement('img');
  img.src = image;
  img.dataset.id = id;

  // Apply current selected size automatically
  if (window.selectedPatchSize) {
    img.classList.add(`patch-${window.selectedPatchSize}`);
  }

  overlay.appendChild(img);
}
  /* ================================
     REMOVE PATCH (QTY BASED)
  ================================ */
  function removePatch(id) {
    if (!selectedPatches[id]) return;

    selectedPatches[id].qty -= 1;

    if (selectedPatches[id].qty <= 0) {
      delete selectedPatches[id];

      const overlayImg = overlay.querySelector(`img[data-id="${id}"]`);
      if (overlayImg) overlayImg.remove();
    }

    updateMySwapsUI();
    updatePrice();
    updatePromo();
  }

  /* ================================
     MY SWAPS UI
  ================================ */
 function updateMySwapsUI() {
  swapList.innerHTML = '';
  let count = 0;

  Object.entries(selectedPatches).forEach(([id, patch]) => {
    count += patch.qty;

    swapList.insertAdjacentHTML('beforeend', `
      <div class="swap-item" data-id="${id}">
        <img src="${patch.image}" alt="">
        <span class="qty-badge">×${patch.qty}</span>
        <button class="remove-swap" type="button">×</button>
      </div>
    `);
  });

  swapCountEl.innerText = count;

  if (count === 0) {
    bundleHint.style.display = 'flex';
    firstPatchAdded = false;
  }
}

  /* ================================
     REMOVE FROM SWAP LIST
  ================================ */
  swapList.addEventListener('click', function (e) {
    const btn = e.target.closest('.remove-swap');
    if (!btn) return;

    const id = btn.closest('.swap-item').dataset.id;
    removePatch(id);
  });

  /* ================================
     PRICE
  ================================ */
 function updatePrice() {
  let patchSubtotal = 0;

  Object.values(selectedPatches).forEach(p => {
    patchSubtotal += p.price * p.qty;
  });

  // ✅ FINAL TOTAL = BASE + PATCHES (no discount)
  const finalTotal = basePrice + patchSubtotal;

  priceEl.innerText = formatMoney(finalTotal);

  // ❌ Remove discount UI
  const discountInfo = document.getElementById('discountInfo');
  if (discountInfo) {
    discountInfo.innerHTML = '';
  }
}


/* ================= ADD TO CART ================= */
addToCartBtn.addEventListener('click', async function () {

  const params = new URLSearchParams(location.search);
  const baseVariantId = Number(params.get('base'));
  const baseSize = params.get('size');

  if (!baseVariantId || isNaN(baseVariantId) || !baseSize) {
    alert('Please select base and size first');
    return;
  }

  if (!Object.keys(selectedPatches).length) {
    alert('Please select at least one patch');
    return;
  }

  const items = [];

  /* BASE */
  items.push({
    id: baseVariantId,
    quantity: 1,
    properties: {
      _bundle: "true", 
      Type: "Base",
      Size: baseSize
    }
  });

  /* PATCHES */
  Object.entries(selectedPatches).forEach(([variantId, patch]) => {

    const id = Number(variantId);
    const qty = Number(patch.qty);

    if (!id || isNaN(id) || !qty || qty <= 0) return;

    items.push({
      id: id,
      quantity: qty,
      properties: {
        _bundle: "true",
        Type: "Patch",
        BaseSize: baseSize
      }
    });

  });

  if (!items.length) {
    alert("No valid items");
    return;
  }

  try {

    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items })
    });

    const data = await res.json();

    if (!res.ok) {
      console.error("Cart Error:", data);
      alert(data.description || 'Cart error');
      return;
    }

    /* ✅ SUCCESS */
    window.location.href = '/pages/bundle-cart?kiosk=true';

  } catch (e) {
    console.error(e);
    alert('Add to cart failed');
  }

});

  /* ================================
     PROMO LOGIC
  ================================ */
  function updatePromo() {
    let count = 0;
    Object.values(selectedPatches).forEach(p => count += p.qty);

    let discount = 0;
    let progress = 0;
    let message = '';

    if (count === 0) {
      message = 'Add 1 swap to get 10% OFF';
    } else if (count === 1) {
      discount = 10; progress = 25;
      message = 'Add 1 more swap to get 15% OFF';
    } else if (count === 2) {
      discount = 15; progress = 50;
      message = 'Add 1 more swap to get 17% OFF';
    } else if (count <= 4) {
      discount = 17; progress = 75;
      message = 'Add 1 more swap to get 20% OFF';
    } else {
      discount = 20; progress = 100;
      message = '🎉 You unlocked 20% OFF!';
    }

    promoProgress.style.width = progress + '%';
    promoText.innerHTML = discount
      ? `<strong>${discount}% OFF</strong> — ${message}`
      : message;
  }

  /* ================================
     COLLECTION FILTER
  ================================ */
  document.querySelectorAll('.collection-tab').forEach(tab => {
  tab.addEventListener('click', function (e) {

    // If it was a drag, block click
    if (isDragging) {
      e.preventDefault();
      return;
    }

    const handle = this.dataset.handle;

    document.querySelectorAll('.collection-tab')
      .forEach(t => t.classList.remove('active'));
    this.classList.add('active');

    document.querySelectorAll('.patch-item').forEach(patch => {
      if (handle === 'all' || patch.dataset.collection === handle) {
        patch.style.display = '';
      } else {
        patch.style.display = 'none';
      }
    });

  });
});


  /* ================================
     STYLE & DETAILS POPUPS
  ================================ */
  document.addEventListener('click', function (e) {

  /* =========================
     OPEN STYLE POPUP
  ========================== */
  if (e.target.closest('#openStylePopup')) {
    styleModal.classList.add('active');
  }

  /* =========================
     OPEN DETAILS POPUP (BASE)
  ========================== */
if (e.target.closest('#openDetailsPopup')) {

  const contentBox = document.getElementById('detailsContent');
  const detailsModal = document.getElementById('detailsModal');

  const urlParams = new URLSearchParams(window.location.search);
  const baseHandle = urlParams.get('baseHandle');

  if (!baseHandle) {
    contentBox.innerHTML = "No base selected.";
    detailsModal.classList.add('active');
    return;
  }

  contentBox.innerHTML = "Loading...";
  detailsModal.classList.add('active');

  fetch(`/products/${baseHandle}.js`)
    .then(res => res.json())
    .then(product => {
      contentBox.innerHTML =
        product.description || "No description available.";
    })
    .catch(() => {
      contentBox.innerHTML = "Unable to load description.";
    });
}
  /* =========================
     CLOSE BOTH POPUPS
  ========================== */
 if (e.target.classList.contains('close-modal') ||
    e.target.closest('.close-modal')) {

  styleModal?.classList.remove('active');
  detailsModal?.classList.remove('active');
}

});
  /* ================================
   CHANGE STYLE (BASE SWITCH)
================================ */
document.querySelectorAll('.style-item').forEach(item => {

  item.addEventListener('click', function () {

    const baseId = this.dataset.baseId;   // variant id
    const image  = this.dataset.image;    // 2nd image
    const thumb  = this.dataset.thumb;    // small thumb
    const title  = this.dataset.title;
    const material = this.dataset.material;

    if (!baseId) return;


if (baseId && window.BASE_LOOKUP?.[baseId]) {
  basePrice = Number(window.BASE_LOOKUP[baseId].price || 0);
  updatePrice();
}
    /* 🔹 Update main image (2nd image) */
    if (mainImage && image) {
      mainImage.src = image;
    }

    /* 🔹 Update pill thumbnail */
    if (pillThumb && thumb) {
      pillThumb.src = thumb;
    }

    if (material) {

      // Remove old jacket-* classes
      imageWrapper.className = imageWrapper.className
      .split(' ')
      .filter(cls => !cls.startsWith('jacket-'))
      .join(' ');

    imageWrapper.classList.add('jacket-' + material);
    }

    /* ✅ ADD PRODUCT TITLE CLASS HERE */
    if (title) {

      const cleanTitle = 'product-' + title.toLowerCase().replace(/\s+/g, '-');

      // Remove previous product-* classes
      imageWrapper.className = imageWrapper.className
        .split(' ')
        .filter(cls => !cls.startsWith('product-'))
        .join(' ');

      imageWrapper.classList.add(cleanTitle);
    }

    /* 🔹 Update global base state */
    window.bundleBase = {
      variantId: baseId,
      title: title,
      size: sizeFromUrl
    };

    /* 🔹 Update URL without reload */
    const url = new URL(window.location);

// Update base variant
url.searchParams.set('base', baseId);

// 🔥 Update baseHandle (important)
if (this.dataset.handle) {
  url.searchParams.set('baseHandle', this.dataset.handle);
}

// 🔥 Update material
if (material) {
  url.searchParams.set('material', material);
}

// 🔥 Keep current size from selected radio/select
const selectedSize =
  document.querySelector('input[name="Size"]:checked')?.value ||
  document.querySelector('select[name*="Size"]')?.value ||
  sizeFromUrl;

if (selectedSize) {
  url.searchParams.set('size', selectedSize);
}

// Apply updated URL without reload
window.history.replaceState({}, '', url);

    /* 🔹 Highlight active style */
    document.querySelectorAll('.style-item')
      .forEach(el => el.classList.remove('active'));

    this.classList.add('active');

    styleModal.classList.remove('active');

  });

});


  /* ================================
     SWAP / PROMO TOGGLE
  ================================ */
  document.querySelectorAll('.toggle-btn').forEach(btn => {
    btn.addEventListener('click', function () {

      document.querySelectorAll('.toggle-btn')
        .forEach(b => b.classList.remove('active'));
      btn.classList.add('active');

      document.getElementById('swapPanel')
        .classList.toggle('active', btn.dataset.target === 'swaps');
      document.getElementById('promoPanel')
        .classList.toggle('active', btn.dataset.target === 'promo');
    });
  });


  /* ================================
   INFINITE SCROLL – PATCH GRID
================================ */

const PATCHES_PER_LOAD = 12;
let visibleCount = PATCHES_PER_LOAD;
let activeCollection = 'all';

const patchItems = Array.from(document.querySelectorAll('.patch-item'));
const sentinel = document.getElementById('patchSentinel');


/* Render patches based on collection + count */
function renderPatches() {
  let shown = 0;

  patchItems.forEach(patch => {
    const matches =
      activeCollection === 'all' ||
      patch.dataset.collection === activeCollection;

    if (matches && shown < visibleCount) {
      patch.style.display = '';
      shown++;
    } else {
      patch.style.display = 'none';
    }
  });
}

/* Initial render (12 items) */
renderPatches();



/* Toggle click */
document.querySelectorAll('.patch-toggle-btn').forEach(btn => {
  btn.addEventListener('click', function () {

    document.querySelectorAll('.patch-toggle-btn')
      .forEach(b => b.classList.remove('active'));

    this.classList.add('active');

    activeCollection = this.dataset.collection;
    visibleCount = PATCHES_PER_LOAD;

    renderPatches();
  });
});

/* Observe bottom sentinel */
const observer = new IntersectionObserver(entries => {
  if (entries[0].isIntersecting) {
    visibleCount += PATCHES_PER_LOAD;
    renderPatches();
  }
}, {
  rootMargin: '200px' // preload before reaching bottom
});

observer.observe(sentinel);


// scroll load more for collection
document.querySelectorAll('.collection-tab').forEach(tab => {
  tab.addEventListener('click', function () {

    if (isDragging) return;

    document.querySelectorAll('.collection-tab')
      .forEach(t => t.classList.remove('active'));

    this.classList.add('active');

    activeCollection = this.dataset.handle;
    visibleCount = PATCHES_PER_LOAD;

    renderPatches();
  });
});


const wishlistModal = document.getElementById('wishlistModal');

document.addEventListener('click', function (e) {

  // CLOSE BUTTON
  if (e.target.closest('.close-wishlist-modal')) {
    wishlistModal?.classList.remove('active');
  }

  // CLICK OUTSIDE
  if (e.target.id === 'wishlistModal') {
    wishlistModal?.classList.remove('active');
  }

});



// Swiper///////////////////////////////////////////////

const tabs = document.getElementById('collectionTabs');

let isDown = false;
let startX = 0;
let scrollStart = 0;
let isDragging = false;

tabs.addEventListener('mousedown', (e) => {
  isDown = true;
  isDragging = false;
  startX = e.pageX;
  scrollStart = tabs.scrollLeft;
  tabs.classList.add('dragging');
});

tabs.addEventListener('mousemove', (e) => {
  if (!isDown) return;

  const dx = e.pageX - startX;

  if (Math.abs(dx) > 5) isDragging = true;

  tabs.scrollLeft = scrollStart - dx;
});

tabs.addEventListener('mouseup', () => {
  isDown = false;
  tabs.classList.remove('dragging');
});

tabs.addEventListener('mouseleave', () => {
  isDown = false;
  tabs.classList.remove('dragging');
});

});

